import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { LayoutSkeleton } from 'hb-react/shared/apps/Events/pages/Booking/components/Layout';
import { useBooking } from 'hb-react/shared/apps/Events/pages/Booking/hooks/useBooking';
import { useAmplitude } from 'hb-react/shared/hooks/useAmplitude';

export const InitPage = () => {
  const {
    event,
    actions: { init },
  } = useBooking();

  const { trackEvent } = useAmplitude();
  const navigate = useNavigate();

  useEffect(() => {
    if (!event) {
      return;
    }

    if (!event.tickets?.[0]?.currency) {
      navigate('..');

      return;
    }

    init({ cart: { currency: event.tickets[0].currency } }).then(({ data }) => {
      trackEvent('NetworkEvents|User enters registration process', {
        event: event.title,
        event_id: event.id,
        event_currency: event.tickets[0].currency.code,
        cart_total: data.cart.total,
        payment_gateway: data._metadata?.payment_gateway?.type,
      });

      navigate(`${data.cart.id}/ticket-selection`, { replace: true });
    });
  }, [init, event, navigate, trackEvent]);

  return <LayoutSkeleton />;
};
